import { render, staticRenderFns } from "./Erro02View.vue?vue&type=template&id=869d7abe&"
import script from "./Erro02View.vue?vue&type=script&lang=ts&"
export * from "./Erro02View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports